import React, { MouseEvent, ReactNode } from 'react';

interface DropdownMenuItemProps {
  children: ReactNode;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export const DropdownMenuItem = ({
  children,
  onClick,
  className = '',
}: DropdownMenuItemProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick(event);
  };

  return (
    <button
      onClick={handleClick}
      className={`block w-full rounded px-4 py-2 text-sm text-gray-dark duration-300 hover:bg-secondary hover:text-primary focus:outline-none ${className}`}
    >
      {children}
    </button>
  );
};
